import styled from 'styled-components';
import { Button } from './Button';
export var ButtonLined = styled(Button).withConfig({
  displayName: "ButtonLined",
  componentId: "sc-ykl133-0"
})(["border:1px solid ", ";background-color:transparent;color:", ";transition:background-color 0.15s;&:not([disabled]):hover:focus:active{box-shadow:none;background-color:transparent;}&[disabled]{border:1px solid ", ";cursor:not-allowed;color:", ";}&:not([disabled]):hover{background-color:", ";color:#fff;}"], function (_ref) {
  var theme = _ref.theme,
    secondary = _ref.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
}, function (_ref2) {
  var theme = _ref2.theme,
    secondary = _ref2.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiL;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.fontLL;
}, function (_ref5) {
  var theme = _ref5.theme,
    secondary = _ref5.secondary;
  return secondary ? theme.secondaryButtonColor : theme.buttonColor;
});